import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { ENDPOINT_PERMISSION_RULES } from 'src/app/config/endpoint-permission.rules';
import { ENDPOINT_PERMISSION_EXTRA_RULES } from 'src/app/config/endpoint-permission.rules.extra';
import {
  ENDPOINT_PERMISSION_INTERCEPTOR_ENABLED,
  ENDPOINT_PERMISSION_LOG_DENIED,
  ENDPOINT_PERMISSION_LOG_UNMATCHED,
} from 'src/app/config/permission-http.config';
import {
  findEndpointPermissionRule,
  isAccessGranted,
  normalizeApiPath,
  shouldSkipEndpointPermissionCheck,
} from './endpoint-permission.matcher';
import { PermissionActionService } from './permission-action.service';
import { PermissionService } from './permission.service';
import { CLIENT_PERMISSION_DENIED_FLAG } from './permission-error.util';

@Injectable({ providedIn: 'root' })
export class PermissionHttpInterceptor implements HttpInterceptor {
  private readonly rules = [
    ...ENDPOINT_PERMISSION_EXTRA_RULES,
    ...ENDPOINT_PERMISSION_RULES,
  ];

  constructor(
    private permissionService: PermissionService,
    private permissionAction: PermissionActionService,
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    if (!ENDPOINT_PERMISSION_INTERCEPTOR_ENABLED) {
      return next.handle(request);
    }

    if (!this.permissionService.isEnforcementReady) {
      return next.handle(request);
    }

    const path = normalizeApiPath(request.url);
    if (shouldSkipEndpointPermissionCheck(path)) {
      return next.handle(request);
    }

    const rule = findEndpointPermissionRule(
      request.method,
      request.url,
      this.rules,
      ENDPOINT_PERMISSION_EXTRA_RULES.length,
    );

    if (!rule) {
      if (ENDPOINT_PERMISSION_LOG_UNMATCHED) {
        console.debug('[PermissionHttpInterceptor] unmatched', request.method, path);
      }
      return next.handle(request);
    }

    const allowed = isAccessGranted(
      rule,
      (key) => this.permissionService.hasRead(key),
      (key) => this.permissionService.hasWrite(key),
    );

    if (allowed) {
      return next.handle(request);
    }

    if (ENDPOINT_PERMISSION_LOG_DENIED) {
      const requiredPermission =
        rule.permissionKeys?.length
          ? rule.permissionKeys.join(' | ')
          : rule.permissionKey ?? '?';
      console.warn(
        `[Permission] ENGELLENDİ: ${request.method} ${path} → ${requiredPermission} (${rule.access})`,
      );
    }

    this.permissionAction.showDenied();
    return throwError(
      () =>
        new HttpErrorResponse({
          status: 403,
          statusText: 'Forbidden',
          url: request.url,
          error: {
            message: 'Yetkiniz Bulunmamaktadır',
            [CLIENT_PERMISSION_DENIED_FLAG]: true,
          },
        }),
    );
  }
}
